// extracted by mini-css-extract-plugin
export default {"title-content":"best-for-you-custom-card-module__title-content--OGY","titleContent":"best-for-you-custom-card-module__title-content--OGY"};